import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cont" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row mt-12" }
const _hoisted_4 = { class: "footer" }

import { ref, watch } from 'vue'
import { ElDialog, ElInput, ElButton, ElSelect, ElOption, ElTreeSelect, ElMessage } from 'element-plus'
import { getFolderTree, appendFileToFolder } from '@/api/affairs'
import { useSdkStore } from '@/stores/sdk'
import { resourceMove, resourceCopy } from '@/api/ResourceMasonry'
import { useUserStore } from '@/stores/user'

export default /*@__PURE__*/_defineComponent({
  __name: 'saveAs',
  setup(__props) {

const sdkStore = useSdkStore()
const desginsdk = sdkStore.getSdk()
const userStore = useUserStore()
const dialogVisible = ref(false)
const saveSpace = ref('2')
const selectedFolderId = ref('')
const folderList = ref<any[]>([])

const onConfirm = async () => {
    console.log(window.location.search)
    const urlParams = new URLSearchParams(window.location.search)
    const fileId = urlParams.get('id')
    // let params = {
    //     //@ts-ignore
    //     corp_code: saveSpace.value == '1' ? "" : Auth.ins.currentTeam.corp_code,
    //     folder_id: selectedFolderId.value,
    //     file_id: fileId,
    // }
    //@ts-ignore

    let params = {
        kind: 'resource',
        to_owner_type: saveSpace.value === '1' ? 'user' : 'team',
        //@ts-ignore
        to_corp_code: saveSpace.value === '1' ? '' : userStore.currentTeamInfo.corp_id,
        to_folder_id: selectedFolderId.value || undefined,
        from_corp_code: '',
        resource_id: fileId,
        folder_id: selectedFolderId.value,
        from_owner_type: 'user',
    }
    resourceCopy(params).then(res => {
        if (res.data?.code == 200) {
            ElMessage.success('另存成功')
        } else {
            ElMessage.error(res.data?.msg || '另存失败')
        }
    })
    dialogVisible.value = false
    // console.log(Auth.ins.currentTeam
    // )
}
watch(dialogVisible, (newVal) => {
    if (newVal) {
        getFolder()
    }
})
const getFolder = () => {
    selectedFolderId.value = ''
    //@ts-ignore
    //@ts-ignore
    getFolderTree({ corp_code: saveSpace.value == '1' ? "" : userStore.currentTeamInfo.corp_id }).then(res => {
        folderList.value = res.data?.data || []
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "w-full h-40px flex items-center px-[15px] cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = true))
    }, "另存为"),
    _createVNode(_unref(ElDialog), {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogVisible).value = $event)),
      title: "另存为",
      width: "380",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "label" }, "作品另存到：", -1)),
            _createVNode(_unref(ElSelect), {
              modelValue: saveSpace.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((saveSpace).value = $event)),
              class: "folder-select",
              placeholder: "选择空间",
              teleported: false,
              onChange: getFolder
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElOption), {
                  label: '我的空间',
                  value: "1"
                }),
                _createVNode(_unref(ElOption), {
                  label: '团队空间',
                  value: "2"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "label" }, "选择文件夹：", -1)),
            _createVNode(_unref(ElTreeSelect), {
              modelValue: selectedFolderId.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedFolderId).value = $event)),
              data: folderList.value,
              "render-after-expand": false,
              "show-checkbox": "",
              "check-strictly": "",
              "check-on-click-node": "",
              "node-key": "folder_id",
              props: { label: 'name', value: 'folder_id', children: 'children' },
              teleported: false,
              "popper-class": "saveas-popper"
            }, {
              default: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.name), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "data"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(ElButton), {
            type: "primary",
            style: {"background-color":"#2a66ff"},
            onClick: onConfirm
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("确认", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})